import { Heading } from '@alto-avios/alto-ui';

type Props = {
  title: string;
};

export const SectionHeading = ({ title }: Props) => {
  return (
    <Heading size="xs" as="h2">
      {title}
    </Heading>
  );
};
